// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1P8OP","paragraph":"styles_paragraph__RU4W4"};